<template>
  <table :id="currentMonthStr" @click.stop.prevent="selectMonth">
    <thead>
      <tr>
        <th
          class="month_name"
          :class="{ 'current-month': isCurrentMonth }"
          colspan="7"
        >
          {{ currentMonthStr }}
        </th>
      </tr>
      <tr>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <week
        :current-month="currentMonth"
        :current-year="currentYear"
        :start-date="1"
      />
      <week
        v-for="start in startDaysOfWeek"
        :key="start"
        :current-month="currentMonth"
        :current-year="currentYear"
        :start-date="start"
      />
    </tbody>
  </table>
</template>

<script>
import WeekVue from "./Week.vue";
import { mapMutations } from "vuex";
import { yearlyMonthlyMonthMixin } from "../../../mixins/yearlyMonthlyMonthMixin.js";
import { monthAndWeekMixin } from "../../../mixins/monthAndWeekMixin.js";

export default {
  mixins: [monthAndWeekMixin, yearlyMonthlyMonthMixin],
  components: {
    Week: WeekVue
  },
  methods: {
    ...mapMutations({
      setMonth: "setMonth"
    }),
    // Open monthy view of the currently selected month and year
    selectMonth() {
      this.setMonth(this.currentMonth - 1);
      this.$router.push("/monthly");
    }
  }
};
</script>

<style scoped>
.month_name {
  cursor: pointer;
}
</style>
